import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import Login from './components/login/Login.jsx';
import ForgetPassword from './components/forget_password/ForgetPassword.jsx';
import Signup from './components/signup/Signup.jsx';
import Customer from './components/customers/Customer.jsx';
import FormCustomer from './components/customers/FormCustomer.jsx';
import Credit from './components/credits/Credit.jsx';
import Dashboard from './components/dashboard/Dashboard.jsx';
import Traceability from './components/traceability/Traceability.jsx';
import ProtectedRoutes from './services/protectedRoutes.tsx';
import PanelAdmin from './components/panel/PanelAdmin.jsx';
import Users from './components/users/Users.jsx';

import { Provider } from 'react-redux';
import { store } from './store/store.js';

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/signup" element={<Signup />} />

        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/form_customer" element={<FormCustomer />} />
          <Route path="/credit" element={<Credit />} />
          <Route path="/traceability" element={<Traceability />} />
          <Route path="/panel_admin" element={<PanelAdmin />} />
          <Route path="/users" element={<Users />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);